export default IconCurrencyLari => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-lari" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18 13a6 6 0 1 0 -6 6" />
  <path d="M6 19h12" />
  <path d="M10 5v7" />
  <path d="M14 12v-7" />
</svg>`;